module.exports = __webpack_public_path__ + "static/img/PUBGpreset.b8e4a956.png";